var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGames(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 50,
    viewBox: "0 0 62 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6998 12.2943C29.0863 12.2943 24.5691 12.079 21.5573 11.2185C15.9103 9.60515 9.14499 9.77301 5.96051 16.5967C2.19565 24.6641 0.516483 35.4283 1.12013 40.2609C1.65757 44.5635 2.73409 46.7148 5.42226 48.3282C7.90555 49.8187 14.0274 48.866 17.2543 45.1013C20.4812 41.3366 22.2022 37.8947 23.1704 35.9584C23.7082 34.8827 24.1384 34.3449 25.8595 34.3449C27.5805 34.3449 29.8034 34.3449 30.6998 34.3449",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6996 12.2943C32.3131 12.2943 36.8303 12.079 39.8421 11.2185C45.4892 9.60515 52.2544 9.77301 55.4389 16.5967C59.2038 24.6641 60.8829 35.4283 60.2793 40.2609C59.7418 44.5635 58.6653 46.7148 55.9772 48.3282C53.4939 49.8187 47.372 48.866 44.1451 45.1013C40.9182 41.3366 39.1972 37.8947 38.2291 35.9584C37.6912 34.8827 37.261 34.3449 35.54 34.3449C33.8189 34.3449 31.596 34.3449 30.6996 34.3449",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7002 12.2943V1",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3379 25.7397H22.0943",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7158 20.3616V31.118",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.1457,
    cy: 30.5801,
    r: 1.61346,
    transform: "rotate(-90 44.1457 30.5801)",
    stroke: "white",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.3049,
    cy: 25.7397,
    r: 1.61346,
    stroke: "white",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.1457,
    cy: 20.8992,
    r: 1.61346,
    transform: "rotate(-90 44.1457 20.8992)",
    stroke: "white",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.9855,
    cy: 25.7397,
    r: 1.61346,
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGames);
export default __webpack_public_path__ + "static/media/games.37b7adb0.svg";
export { ForwardRef as ReactComponent };